/**
 * Generated by orval v6.19.1 🍺
 * Do not edit manually.
 * BBO Accounting Location Api
 * Accounting Location API defining how to get and modify Accounting Locations

REST APIs for Back Office stock count service. This service is specifically designed for stock functionality- stock count. Feature services are.<ul><li>Get Stock Count Type List</li></ul>

REST APIs for Back Office Forex Management Service. This service is specifically designed for forex functionality- forex counting, variance declaration, forex details, and etc. Feature services are.<ul><li>Branch Forex Overview</li><li>Fetch the Forex currencies</li></ul>

Provide Task Status and Uncompleted Task History
 * OpenAPI spec version: 0.1.0
 */
import { useQuery } from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  BboForexManagementBadRequestResponse,
  BboForexManagementFailureResponseResponse,
  BboForexManagementForbiddenResponse,
  BboForexManagementUnauthorizedResponse,
  NotFoundResponse,
  PouchDetailsResponseResponse,
} from '../model';
import { customInstance } from '../mutator/customInstance';
import type { ErrorType } from '../mutator/customInstance';

/**
 * Get the list currencies available in the pouch.
 * @summary Get the currencies available in the pouch.
 */
export const getPouchDetails = (pouchID: string, signal?: AbortSignal) => {
  return customInstance<PouchDetailsResponseResponse>({
    url: `/BboForexManagementService/v1/pouch-details/${pouchID}`,
    method: 'get',
    signal,
  });
};

export const getGetPouchDetailsQueryKey = (pouchID: string) => {
  return [`/BboForexManagementService/v1/pouch-details/${pouchID}`] as const;
};

export const getGetPouchDetailsQueryOptions = <
  TData = Awaited<ReturnType<typeof getPouchDetails>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchDetails>>, TError, TData>>;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetPouchDetailsQueryKey(pouchID);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getPouchDetails>>> = ({ signal }) =>
    getPouchDetails(pouchID, signal);

  return { queryKey, queryFn, enabled: !!pouchID, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getPouchDetails>>,
    TError,
    TData
  > & { queryKey: QueryKey };
};

export type GetPouchDetailsQueryResult = NonNullable<Awaited<ReturnType<typeof getPouchDetails>>>;
export type GetPouchDetailsQueryError = ErrorType<
  | BboForexManagementBadRequestResponse
  | BboForexManagementUnauthorizedResponse
  | BboForexManagementForbiddenResponse
  | NotFoundResponse
  | BboForexManagementFailureResponseResponse
>;

/**
 * @summary Get the currencies available in the pouch.
 */
export const useGetPouchDetails = <
  TData = Awaited<ReturnType<typeof getPouchDetails>>,
  TError = ErrorType<
    | BboForexManagementBadRequestResponse
    | BboForexManagementUnauthorizedResponse
    | BboForexManagementForbiddenResponse
    | NotFoundResponse
    | BboForexManagementFailureResponseResponse
  >,
>(
  pouchID: string,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getPouchDetails>>, TError, TData>>;
  },
): UseQueryResult<TData, TError> & { queryKey: QueryKey } => {
  const queryOptions = getGetPouchDetailsQueryOptions(pouchID, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey;

  return query;
};
